import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { OwnerService } from '../../core/services/owner.service';
import { IpAddressService } from '../../core/services/ip-address.service';
import { MemberService } from '../../core/services/member.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-owner-edit',
    imports: [RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;編集</span>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <!-- 旧版 owner-edit.html:11-13 の col-md-12 先頭 <flash-message> 相当 -->
            <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
            @if (loading) {
              <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
            }
            @if (!loading) {
              <form novalidate name="ownerBaseEditForm" #ownerBaseEditForm="ngForm">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label class="col-form-label">企業名</label>
                        <input type="text" class="form-control" [(ngModel)]="form.name" name="name" required>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label class="col-form-label">適格請求書発行事業者登録番号</label>
                        <div class="d-flex" style="column-gap: 0.5rem;">
                          <span style="margin: auto; font-size: 1.2rem;">T</span>
                          <input type="text" class="form-control" [(ngModel)]="form.invoiceRegistrationNumber" name="invoiceRegistrationNumber" required pattern="^[0-9]{13}$">
                        </div>
                      </div>
                    </div>
                    <div class="row" style="align-items: flex-end;">
                      <div class="form-group col-md-6">
                        <label class="col-form-label">郵便番号</label>
                        <div class="bisected-input-wrap">
                          <div class="bisected-input">
                            <input type="text" class="form-control" [(ngModel)]="form.zip1" name="zip1" required [pattern]="asciiPattern">
                          </div>
                          <span>&nbsp;</span>
                          <div class="bisected-input">
                            <input type="text" class="form-control" [(ngModel)]="form.zip2" name="zip2" required [pattern]="asciiPattern">
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <div class="row">
                          <div class="col-md-12">
                            <button type="button" class="btn btn-primary text-white" (click)="searchZipCode()"><i class="fa s-icon-autoAddress"></i>&nbsp;住所自動入力</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label">住所</label>
                        <div class="quartered-input-wrap">
                          <div class="quartered-input">
                            <input type="text" class="form-control" [(ngModel)]="form.province" name="province" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="text" class="form-control" [(ngModel)]="form.city" name="city" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="text" class="form-control" [(ngModel)]="form.area" name="area" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="text" class="form-control" [(ngModel)]="form.address" name="address">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label class="col-form-label">電話番号</label>
                        <div class="trisection-input-wrap">
                          <div class="trisection-input">
                            <input type="text" class="form-control" [(ngModel)]="form.phone1" name="phone1" required [pattern]="asciiPattern">
                          </div>
                          <span>&nbsp;</span>
                          <div class="trisection-input">
                            <input type="text" class="form-control" [(ngModel)]="form.phone2" name="phone2" required [pattern]="asciiPattern">
                          </div>
                          <span>&nbsp;</span>
                          <div class="trisection-input">
                            <input type="text" class="form-control" [(ngModel)]="form.phone3" name="phone3" required [pattern]="asciiPattern">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-8">
                        <label class="col-form-label">メールアドレス</label>
                        <input type="email" class="form-control" [(ngModel)]="form.email" name="email" email [pattern]="asciiPattern">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label transparent-divider-label">&nbsp;</label>
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" [ngModel]="form.restrictIp == 1" (ngModelChange)="form.restrictIp = $event ? 1 : 0" name="restrict_ip" id="restrict_ip">
                          <label class="custom-control-label" for="restrict_ip">IPアドレスでログインを制限する</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form novalidate name="ipAddressBaseEditForm" #ipAddressBaseEditForm="ngForm" (ngSubmit)="addIpAddress(ipAddressBaseEditForm)">
                <div class="row" style="align-items: flex-end;">
                  <div class="col-md-8">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label class="col-form-label">IPアドレス</label>
                        <div class="quartered-input-wrap">
                          <div class="quartered-input">
                            <input type="number" class="form-control" [(ngModel)]="select.ipAddress1" name="ipAddress1" min="0" max="255" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="number" class="form-control" [(ngModel)]="select.ipAddress2" name="ipAddress2" min="0" max="255" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="number" class="form-control" [(ngModel)]="select.ipAddress3" name="ipAddress3" min="0" max="255" required>
                          </div>
                          <span>&nbsp;</span>
                          <div class="quartered-input">
                            <input type="number" class="form-control" [(ngModel)]="select.ipAddress4" name="ipAddress4" min="0" max="255" required>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <button type="submit" class="btn btn-primary text-white" [disabled]="ipAddressBaseEditForm.invalid"><i class="fa s-icon-plus"></i>&nbsp;登録</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="form-group row">
                <div class="col-md-6">
                  <label>&nbsp;</label>
                  <table class="table-bordered table-sm">
                    <thead>
                      <tr>
                        <th width="20%">状態</th>
                        <th width="60%">IPアドレス</th>
                        <th width="20%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of ipAddresses; track item.id) {
                        <tr>
                          <td class="text-center">
                            @if (item.status == 0) {
                              <button class="btn text-green p-0 bg-inherit active" type="button" (click)="disableIpAddress(item)"><i class="fa fa-3x fa-toggle-on"></i></button>
                            }
                            @if (item.status == 1) {
                              <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="enableIpAddress(item)"><i class="fa fa-3x fa-toggle-off"></i></button>
                            }
                          </td>
                          <td>{{item.ipAddress1}}.{{item.ipAddress2}}.{{item.ipAddress3}}.{{item.ipAddress4}}</td>
                          <td class="text-center">
                            @if (item.status == 0) {
                              <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled title="削除"><i class="fa s-icon-delete fa-fw"></i></button>
                            }
                            @if (item.status == 1) {
                              <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button" (click)="removeIpAddress(item.id)" title="削除"><i class="fa s-icon-delete fa-fw"></i></button>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-right">
                  <a routerLink="/owner" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                  <button type="button" (click)="save(ownerBaseEditForm)" class="btn btn-success" [disabled]="saving || ownerBaseEditForm.invalid"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class OwnerEditComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private ownerService = inject(OwnerService);
  private ipAddressService = inject(IpAddressService);
  private memberService = inject(MemberService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private flash = inject(FlashService);

  form: any = {};
  ipAddresses: any[] = [];
  select: any = {};
  loading = true;
  saving = false;
  private ownerId = 0;
  readonly asciiPattern = '^[\\x01-\\x7E]+$';

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('マスター管理/企業マスター', 's-icon-master');
    this.ownerId = +this.route.snapshot.params['ownerId'];
    try {
      const data: any = await this.ownerService.list(String(this.ownerId));
      this.form = Array.isArray(data) ? (data[0] ?? { id: this.ownerId }) : (data ?? { id: this.ownerId });
      if (!this.form.id) this.form.id = this.ownerId;
      this.splitContactFields();
      await this.loadIpAddresses();
    } finally {
      this.loading = false;
    }
  }

  private async loadIpAddresses(): Promise<void> {
    try {
      this.ipAddresses = await this.ipAddressService.list(String(this.ownerId)) ?? [];
    } catch {
      this.ipAddresses = [];
    }
  }

  async searchZipCode(): Promise<void> {
    const zipCode = `${this.form.zip1 ?? ''}-${this.form.zip2 ?? ''}`;
    if (!zipCode || zipCode === '-') return;
    const address: any = await this.memberService.getAddress(zipCode);
    if (!address) return;
    this.form.province = address.address1;
    this.form.city = address.address2;
    this.form.area = address.address3;
    this.form.address = '';
  }

  private splitContactFields(): void {
    const [zip1 = '', zip2 = ''] = String(this.form.zip ?? '').split('-');
    const [phone1 = '', phone2 = '', phone3 = ''] = String(this.form.phone ?? '').split('-');
    this.form.zip1 = zip1;
    this.form.zip2 = zip2;
    this.form.phone1 = phone1;
    this.form.phone2 = phone2;
    this.form.phone3 = phone3;
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid) {
      form.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const payload = {
        ...this.form,
        zip: `${this.form.zip1}-${this.form.zip2}`,
        phone: `${this.form.phone1}-${this.form.phone2}-${this.form.phone3}`,
      };
      delete payload.zip1;
      delete payload.zip2;
      delete payload.phone1;
      delete payload.phone2;
      delete payload.phone3;
      delete payload.createdAt;
      delete payload.updatedAt;
      await this.ownerService.upsert(payload);
      // 旧版 owner.js:180-184: 先頭へscroll・Flash・再読込
      window.scrollTo(0, 0);
      this.flash.create('success', '企業情報を更新しました');
      const data: any = await this.ownerService.list(String(this.ownerId));
      this.form = Array.isArray(data) ? (data[0] ?? payload) : (data ?? payload);
      this.splitContactFields();
    } finally {
      this.saving = false;
    }
  }

  async addIpAddress(form?: NgForm): Promise<void> {
    if (form?.invalid) {
      form.control.markAllAsTouched();
      return;
    }
    const { ipAddress1, ipAddress2, ipAddress3, ipAddress4 } = this.select;
    if (ipAddress1 == null || ipAddress2 == null || ipAddress3 == null || ipAddress4 == null) return;
    await this.ipAddressService.upsert({ ownerId: this.ownerId, ipAddress1, ipAddress2, ipAddress3, ipAddress4, status: 1 });
    // 旧版 owner.js:191-195: 先頭へscroll・Flash・再読込
    window.scrollTo(0, 0);
    this.flash.create('success', 'IPアドレスを登録しました');
    this.select = {};
    form?.resetForm({});
    await this.loadIpAddresses();
  }

  async disableIpAddress(item: any): Promise<void> {
    await this.ipAddressService.upsert({ id: item.id, status: 1 });
    item.status = 1;
  }

  async enableIpAddress(item: any): Promise<void> {
    await this.ipAddressService.upsert({ id: item.id, status: 0 });
    item.status = 0;
  }

  async removeIpAddress(id: number): Promise<void> {
    await this.ipAddressService.remove(id);
    this.ipAddresses = this.ipAddresses.filter(i => i.id !== id);
  }
}
